// extracted by mini-css-extract-plugin
export default {"ctaButton":"Button_ctaButton__52h2a"};